import { AdFormData } from '../ads/components/Ad/contracts';
import { ArticleCarouselFormData } from '../article/components/ArticleCarousel/contracts';
import { ArticleCardFormData } from '../article/components/ArticleCard/contracts';
import { ArticleFiltersFormData } from '../article/components/ArticleFilters/contracts';
import { ArticleHighlightedCardFormData } from '../article/components/ArticleHighlightedCard/contracts';
import { ArticleListFormData } from '../article/components/ArticleList/contracts';
import { FeaturedTagsFormData } from '../article/components/FeaturedTags/contracts';
import { NewsletterSubscribeFormData } from '../article/components/NewsletterSubscribe/contracts';
import { RichTextPreviewFormData } from '../article/components/RichTextEditor/contracts';
import { LinkFormData } from '../common/components/Link/contracts';
import { FixtureListFormData } from '../fixtures/components/FixtureList/contracts';
import { ContactsListFormData } from '../league/components/ContactsList/contracts';
import { LeagueTableFormData } from '../league/components/LeagueTable/contracts';
import { SocialNetworksFormData } from '../league/components/SocialNetworks/contracts';
import { SponsorCardFormData } from '../league/components/SponsorCard/contracts';
import { SponsorsGridFormData } from '../league/components/SponsorsGrid/contracts';
import { SponsorsCarouselFormData } from '../league/components/SponsorsCarousel/contracts';
import { ClubListFormData } from '../league/components/ClubList/contracts';
import { TeamListFormData } from '../league/components/TeamList/contracts';
import { FaqFormData } from '../faq/components/Faq/contracts';
import { ContactUsFormData } from '@ui/common/components/ContactUs/contracts';
import { TabsFormData } from '../tabs/components/Tabs/contracts';
import { VideoListFormData } from '../video/components/VideoList/contracts';
import { VideoFiltersFormData } from '../video/components/VideoFilters/contracts';
import { VideoCarouselFormData } from '../video/components/VideoCarousel/contracts';
import { PlayersStatsTableFormData } from '../player/components/PlayersStatsTable/contracts';
import { AttendanceCardFormData } from '../attendance/components/AttendanceCard/contracts';
import { AttendanceTableFormData } from '../attendance/components/AttendanceTable/contracts';
import { PhotoAlbumsFormData } from '../photoAlbums/components/PhotoAlbums/contracts';
import { PpvVideoCarouselFormData } from '../ppvVideo/components/PpvVideoCarousel/contracts';
import { StatsFormData } from '../stats/components/Stats/contracts';
import { SeasonFilterFormData } from '../common/components/SeasonFilter/contracts';
import { SectionJumpNavFormData } from '../common/components/SectionJumpNav/contracts';
import { EngagementFormData } from '../engagement/components/Engagement/contracts';
import { EngagementCarouselFormData } from '../engagement/components/EngagementCarousel/contracts';
import { EngagementHistoryFormData } from '../engagement/components/EngagementHistory/contracts';
import { EngagementTeaserFormData } from '../engagement/components/EngagementTeaser/contracts';
import { ImportantDatesListFormData } from '../league/components/ImportantDatesList/contracts';
import { TeamSquadFormData } from '../club/components/TeamSquad/contracts';
import { ImageBlockFormData } from '../common/components/Image/contracts';
import { DividerFormData } from '../common/components/Divider/contracts';

export const CmsComponent = {
  ArticleCarousel: 'ArticleCarousel',
  ArticleCard: 'ArticleCard',
  ArticleFilters: 'ArticleFilters',
  ArticleHighlightedCard: 'ArticleHighlightedCard',
  ArticleList: 'ArticleList',
  RichTextPreview: 'RichTextPreview',
  NewsletterSubscribe: 'NewsletterSubscribe',
  LeagueTable: 'LeagueTable',
  FixtureList: 'FixtureList',
  ClubList: 'ClubList',
  TeamList: 'TeamList',
  SocialNetworks: 'SocialNetworks',
  SponsorCard: 'SponsorCard',
  SponsorsGrid: 'SponsorsGrid',
  SponsorsCarousel: 'SponsorsCarousel',
  Ad: 'Ad',
  FeaturedTags: 'FeaturedTags',
  Link: 'Link',
  ContactsList: 'ContactsList',
  Faq: 'Faq',
  ContactUs: 'ContactUs',
  Tabs: 'Tabs',
  VideoList: 'VideoList',
  VideoFilters: 'VideoFilters',
  VideoCarousel: 'VideoCarousel',
  PlayersStatsTable: 'PlayersStatsTable',
  AttendanceCard: 'AttendanceCard',
  AttendanceTable: 'AttendanceTable',
  PhotoAlbums: 'PhotoAlbums',
  PpvVideoCarousel: 'PpvVideoCarousel',
  Stats: 'Stats',
  SeasonFilter: 'SeasonFilter',
  SectionJumpNav: 'SectionJumpNav',
  Engagement: 'Engagement',
  EngagementCarousel: 'EngagementCarousel',
  EngagementHistory: 'EngagementHistory',
  EngagementTeaser: 'EngagementTeaser',
  ImportantDatesList: 'ImportantDatesList',
  TeamSquad: 'TeamSquad',
  Image: 'Image',
  Divider: 'Divider',
} as const;
export type CmsComponent = (typeof CmsComponent)[keyof typeof CmsComponent];

type ArticleCarouselData = {
  id: string;
  type: typeof CmsComponent.ArticleCarousel;
  data: ArticleCarouselFormData;
};

type ArticleCardData = {
  id: string;
  type: typeof CmsComponent.ArticleCard;
  data: ArticleCardFormData;
};

type ArticleFiltersData = {
  id: string;
  type: typeof CmsComponent.ArticleFilters;
  data: ArticleFiltersFormData;
};

type ArticleHighlightedCardData = {
  id: string;
  type: typeof CmsComponent.ArticleHighlightedCard;
  data: ArticleHighlightedCardFormData;
};

type ArticleListData = {
  id: string;
  type: typeof CmsComponent.ArticleList;
  data: ArticleListFormData;
};

type RichTextPreviewData = {
  id: string;
  type: typeof CmsComponent.RichTextPreview;
  data: RichTextPreviewFormData;
};

type NewsletterSubscribeData = {
  id: string;
  type: typeof CmsComponent.NewsletterSubscribe;
  data: NewsletterSubscribeFormData;
};

type LeagueTableData = {
  id: string;
  type: typeof CmsComponent.LeagueTable;
  data: LeagueTableFormData;
};

type ClubListData = {
  id: string;
  type: typeof CmsComponent.ClubList;
  data: ClubListFormData;
};

type TeamListData = {
  id: string;
  type: typeof CmsComponent.TeamList;
  data: TeamListFormData;
};

type FixtureListData = {
  id: string;
  type: typeof CmsComponent.FixtureList;
  data: FixtureListFormData;
};

type SocialNetworksData = {
  id: string;
  type: typeof CmsComponent.SocialNetworks;
  data: SocialNetworksFormData;
};

type SponsorCardData = {
  id: string;
  type: typeof CmsComponent.SponsorCard;
  data: SponsorCardFormData;
};

type SponsorsGridData = {
  id: string;
  type: typeof CmsComponent.SponsorsGrid;
  data: SponsorsGridFormData;
};

type SponsorsCarouselData = {
  id: string;
  type: typeof CmsComponent.SponsorsCarousel;
  data: SponsorsCarouselFormData;
};

type AdData = {
  id: string;
  type: typeof CmsComponent.Ad;
  data: AdFormData;
};

type FeaturedTagsData = {
  id: string;
  type: typeof CmsComponent.FeaturedTags;
  data: FeaturedTagsFormData;
};

type LinkData = {
  id: string;
  type: typeof CmsComponent.Link;
  data: LinkFormData;
};

type ContactsListData = {
  id: string;
  type: typeof CmsComponent.ContactsList;
  data: ContactsListFormData;
};

type FaqData = {
  id: string;
  type: typeof CmsComponent.Faq;
  data: FaqFormData;
};

type ContactUsData = {
  id: string;
  type: typeof CmsComponent.ContactUs;
  data: ContactUsFormData;
};

type TabsData = {
  id: string;
  type: typeof CmsComponent.Tabs;
  data: TabsFormData;
};

type VideoListData = {
  id: string;
  type: typeof CmsComponent.VideoList;
  data: VideoListFormData;
};

type VideoFiltersData = {
  id: string;
  type: typeof CmsComponent.VideoFilters;
  data: VideoFiltersFormData;
};

type VideoCarouselData = {
  id: string;
  type: typeof CmsComponent.VideoCarousel;
  data: VideoCarouselFormData;
};

type PlayersStatsTableData = {
  id: string;
  type: typeof CmsComponent.PlayersStatsTable;
  data: PlayersStatsTableFormData;
};

type AttendanceCardData = {
  id: string;
  type: typeof CmsComponent.AttendanceCard;
  data: AttendanceCardFormData;
};

type AttendanceTableData = {
  id: string;
  type: typeof CmsComponent.AttendanceTable;
  data: AttendanceTableFormData;
};

type PhotoAlbumsData = {
  id: string;
  type: typeof CmsComponent.PhotoAlbums;
  data: PhotoAlbumsFormData;
};

type PpvVideoCarouselData = {
  id: string;
  type: typeof CmsComponent.PpvVideoCarousel;
  data: PpvVideoCarouselFormData;
};

type StatsData = {
  id: string;
  type: typeof CmsComponent.Stats;
  data: StatsFormData;
};

type SeasonFilterData = {
  id: string;
  type: typeof CmsComponent.SeasonFilter;
  data: SeasonFilterFormData;
};

type SectionJumpNavData = {
  id: string;
  type: typeof CmsComponent.SectionJumpNav;
  data: SectionJumpNavFormData;
};

type EngagementData = {
  id: string;
  type: typeof CmsComponent.Engagement;
  data: EngagementFormData;
};

type EngagementCarouselData = {
  id: string;
  type: typeof CmsComponent.EngagementCarousel;
  data: EngagementCarouselFormData;
};

type EngagementHistoryData = {
  id: string;
  type: typeof CmsComponent.EngagementHistory;
  data: EngagementHistoryFormData;
};

type EngagementTeaserData = {
  id: string;
  type: typeof CmsComponent.EngagementTeaser;
  data: EngagementTeaserFormData;
};

type ImportantDatesListData = {
  id: string;
  type: typeof CmsComponent.ImportantDatesList;
  data: ImportantDatesListFormData;
};

type TeamSquadData = {
  id: string;
  type: typeof CmsComponent.TeamSquad;
  data: TeamSquadFormData;
};

type ImageData = {
  id: string;
  type: typeof CmsComponent.Image;
  data: ImageBlockFormData;
};

type DividerData = {
  id: string;
  type: typeof CmsComponent.Divider;
  data: DividerFormData;
};

export type ComponentData =
  | ArticleCarouselData
  | ArticleCardData
  | ArticleFiltersData
  | ArticleHighlightedCardData
  | ArticleListData
  | RichTextPreviewData
  | NewsletterSubscribeData
  | LeagueTableData
  | FixtureListData
  | ClubListData
  | TeamListData
  | SocialNetworksData
  | SponsorCardData
  | SponsorsGridData
  | SponsorsCarouselData
  | AdData
  | FeaturedTagsData
  | LinkData
  | ContactsListData
  | FaqData
  | ContactUsData
  | TabsData
  | VideoListData
  | VideoFiltersData
  | VideoCarouselData
  | PlayersStatsTableData
  | AttendanceCardData
  | AttendanceTableData
  | PhotoAlbumsData
  | PpvVideoCarouselData
  | StatsData
  | SeasonFilterData
  | SectionJumpNavData
  | EngagementData
  | EngagementCarouselData
  | EngagementHistoryData
  | EngagementTeaserData
  | ImportantDatesListData
  | TeamSquadData
  | ImageData
  | DividerData;
